/**
 * A boss: intense. The pipa leads, the zheng hammers a low ostinato with the flat second (b7 over
 * the 羽 tonic A), big drums and gongs; in the middle the erhu cries over half-time drums.
 */
import { drone } from '../compose';
import { registerTrack } from '../registry';

const OST = `6,,_ 6,,_ b7,,_ 6,,_ 3,_ 6,,_ b7,,_ 3,_`;
const OST_G = `5,,_ 5,,_ 6,,_ 5,,_ 2,_ 5,,_ 6,,_ 2,_`;
const A_PIPA = `@f 6! 6_ b7_ 6 3 | 6%- 5_ 3_ 2 | 3! 5_ 6_ 1'! 2' | 3'%--- |
  2'_ 1'_ b7_ 6_ 5 6 | 1'_ 6_ 5_ 3_ 6- | 3_ 5_ 6_ b7_ 6_ 5_ 3_ 2_ | 6,%-- 6!`;
const BEAT = `D_ D_ d_ D_ 0_ D_ d_ d_`;
const DRUMS_A = [`G&D_ D_ d_ D_ 0_ D_ d_ d_`, BEAT, BEAT, BEAT, `c&D_ D_ d_ D_ 0_ D_ d_ d_`, BEAT, BEAT, `D_ D_ D_ D_ D_ D_ d_ d_`].join(' | ');

const B_ZHENG = `@f 6'%- 5'_ 3'_ 2' | 3'%--- | 2'_ 1'_ 6_ 5_ 6 1'^ | b7%--- |
  6%- 1'_ 2'_ 3' | 5'_ 3'_ 2'_ 1'_ 2'\\- | 3'_ 2'_ 1'_ 6_ 5_ 6_ 1'_ 2'_ | 6'G-- 0`;
const strum = (lo: string, hi: string) => `${lo}&${hi}!_ 0_ ${lo}&${hi}_ ${lo}&${hi}_ 0_ ${lo}&${hi}_ ${lo}&${hi}!_ 0_`;
const B_PIPA = [strum('6,', '3'), strum('6,', '3'), strum('5,', '2'), strum('b7,', '4'), strum('6,', '3'), strum('5,', '2'), strum('3,', '6,'), strum('6,', '3')].join(' | ');
const DRUMS_B = [...Array(7).fill(`D_ 0_ D_ D_ d_ 0_ D_ d_`), `D_ D_ D_ D_ G&D-`].join(' | ');

const C_ERHU = `@f 6'/--- | 5'\\--- | 3'/- 2'- | 3'~--- ; | 6'/--- | b7'^- 6'- | 5'_ 3'_ 2'_ 3'_ 5'- | 6'~---`;
const C_BASS = `@mf 6,,%--- | 6,,%--- | 5,,%--- | 6,,%--- | 6,,%--- | b7,,%--- | 5,,%--- | 6,,%---`;
const C_DRUMS = `G&D--- | D- D- | D--- | D- d d | G&D--- | D- D- | D_ D_ D_ D_ D D | d_ d_ d_ d_ D&c_ D&c_ D&c_ 0_`;

registerTrack({
  id: 'boss',
  order: 17,
  title: 'ศึกชี้เป็นชี้ตาย',
  mood: 'ดุเดือด กดดัน อันตราย',
  use: 'ใกล้บอสและบอสโลก',
  key: 'C',
  mode: 'yu',
  bpm: 150,
  meter: 4,
  seed: 1717,
  humanize: 0.2,
  parts: {
    pipa: { inst: 'pipa', pan: 0.15, reverb: 0.25 },
    zheng: { inst: 'zheng', pan: -0.05, reverb: 0.25 },
    bass: { inst: 'zheng', gain: 0.6, pan: -0.2, reverb: 0.15 },
    erhu: { inst: 'erhu', gain: 1.1, pan: -0.15, reverb: 0.35 },
    pad: { inst: 'pad', gain: 0.9, reverb: 0.35 },
    drums: { inst: 'perc', gain: 0.55, reverb: 0.25 },
  },
  sections: {
    A: {
      bars: 8,
      parts: {
        pipa: A_PIPA,
        bass: `@mf ${[OST, OST, OST, OST, OST_G, OST_G, OST, OST].join(' | ')}`,
        pad: drone(`6,, 6,, 6,, 6,, 5,, 5,, 6,, 6,,`, 4),
        drums: DRUMS_A,
      },
    },
    B: {
      bars: 8,
      parts: {
        zheng: B_ZHENG,
        pipa: `@mf ${B_PIPA}`,
        bass: `@mf ${[OST, OST, OST_G, OST, OST, OST_G, OST, OST].join(' | ')}`,
        pad: drone(`6,, 6,, 5,, 6,, 6,, 5,, 3,, 6,,`, 4),
        drums: DRUMS_B,
      },
    },
    C: {
      bars: 8,
      parts: { erhu: C_ERHU, bass: C_BASS, pad: drone(`6,, 6,, 5,, 6,, 6,, 6,, 5,, 6,,`, 4), drums: C_DRUMS },
    },
  },
  form: ['A', 'B', 'A', 'C', 'B', 'A'],
  loop: true,
});
